<template>
  <!-- celý label je klikateľný -->
  <label class="flex w-full items-center cursor-pointer">
    <!-- skutočný input (skrytý, ale fokusovateľný) -->
    <input
      type="radio"
      :name="name"
      :value="value"
      v-model="model"
      :disabled="disabled"
      class="peer sr-only"
    />

    <!-- vizuálny krúžok — PRIAMY súrodenec inputu -->
    <span
      class="mr-3 inline-block w-[14px] h-[14px] rounded-full border border-[#A3A3A3]
             peer-checked:border-[#141414]
             peer-checked:bg-[radial-gradient(circle,_#141414_0,_#141414_60%,_transparent_61%)]
             peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-black/40"
    ></span>

    <!-- Sloty -->
    <span class="font-medium text-[18px] leading-[150%] text-black">
      <slot name="left" />
    </span>
    <span class="ml-auto font-medium text-[18px] leading-[150%] text-black">
      <slot name="right" />
    </span>
  </label>
</template>

<script setup lang="ts">
// v-model binding na hodnotu rádia
const model = defineModel<string | number>()

defineProps<{
  name: string
  value: string | number
  disabled?: boolean
}>()
</script>
